export enum UserRole {
  None = 0,
  Lead = 1,
  Team = 2,
  OpsRep = 3,
  Approver = 4,
  Translator = 5
}
